import {axios as http} from "@/plugins/http"

export default class Api {
    static syncSlugByTitle(shopId, title) {
        return http.post("/api/v1/shop/shop/sync-slug-by-title", {
            shop_id: shopId,
            title: title,
        });
    }
}
